import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import './ToastNotification.css';

// Props for ToastNotification.
export interface ToastNotificationProps {
  open: boolean;
  message: string;
  severity?: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
}

const ToastNotification: React.FC<ToastNotificationProps> = ({ open, message, severity = 'success', onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      onClose={(event: React.SyntheticEvent<any> | Event, reason: string) => {
        if (reason === 'clickaway') return;
        onClose();
      }}
    >
      <Alert severity={severity} onClose={onClose} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ToastNotification;